// extracted by mini-css-extract-plugin
export default {"actions":"RoomForm_actions__AOLpL","wrapper":"RoomForm_wrapper__s9XbL"};